import { AfterViewInit, Component, OnInit, Output } from '@angular/core';
import { BaseComponent } from 'src/app/core/base.component';
import { SessionService } from 'src/app/shared/services/session.service';
import { IterationHistoryCounts } from './models/iteration-history-counts';
import { DashboardService } from '../dashboard.service';
import { GlobalDataService } from 'src/app/shared/services/global-data.service';
import { StringHelpers } from 'src/app/shared/helpers/string-helpers';

@Component({
    selector: 'dashboard-organizer',
    templateUrl: './dashboard-organizer.component.html',
    styleUrls: ['./dashboard-organizer.component.scss'],
    standalone: false
})
export class DashboardOrganizerComponent extends BaseComponent implements OnInit, AfterViewInit {
  public iterationHistoryCounts: IterationHistoryCounts[] = [];
  public outingsAndIterations: any = [];
  public displayedColumns: string[] = ['totalHasPaid', 'totalCheckedIn', 'total', 'startDate'];

  constructor(public sessionService: SessionService,
    private dashboardService: DashboardService,
    private globalDataService: GlobalDataService,
    stringHelpers: StringHelpers) {
    super(sessionService, stringHelpers)
  }

  ngOnInit(): void {
    if (this.sessionService.isUserLoggedIn()) {
      this.getOutingsAndIterations();
    }

    if(this.isGlobalOutingSet()){
      this.getIterationHistoryCounts();
    }
  }

  ngAfterViewInit(): void {
    this.globalDataService.postLoginEvent.subscribe(() => {
      this.getOutingsAndIterations();
    });

    this.globalDataService.iterationSelectionEvent.subscribe(iteration => {
      this.getIterationHistoryCounts();
      this.setSelectedOutingAndIteration();
    });
  }

  getOutingsAndIterations() {
    this.isLoading;
    this.dashboardService.getOutingsAndIterationsByOrganization(this.sessionService.getUser().organizationId).subscribe({
      next: (result) => {
        this.outingsAndIterations = result.outings;
        this.globalDataService.postDashboardLoadEvent.emit(this.outingsAndIterations);
      },
      error: (err) => {
        this.isLoading = false;
        console.log(err);
      },
      complete: () => this.isLoading = false
    });
  }

  setSelectedOutingAndIteration() {
    this.selectedIteration = this.sessionService.getGlobalOutingIteration();
    this.selectedOuting = this.sessionService.getGlobalOuting();
  }

  getIterationHistoryCounts() {
    this.isLoading = true;
    this.dashboardService.getIterationHisotryCounts(this.sessionService.getGlobalOuting().id).subscribe(result => {
      this.iterationHistoryCounts = result;
      this.isLoading = false;
    }, err => {
      this.isLoading = false;
    });
  }
}
